import angular from 'angular';
import config from './informations.config';

import {SchedulePoints} from './schedule-points/schedule-points.component';
import {Targets} from './targets/targets.component';
import {Activities} from './activities/activities.component';
import {WorkingDays} from './working-days/working-days.component';
import {CategoriesOfDeparture} from './categories-of-departure/categories-of-departure.component';
import {StudentList} from './student-list/student-list.component';
import {Groups} from './groups/groups.component';
import {Employees} from './employees/employees.component';
import {SchoolClasses} from './school-classes/school-classes.component';
import {Permissions} from './permissions/permissions.component';
import {Tags} from './tags/tags.component';
import {EditTag} from './tags/edit-tag/edit-tag.component';
import {DataModification} from './permissions/dataModificationLock/dataModificationLock.component';

import InformationsController from './informations.controller';
import ViewGroupRegisterController from './group-register/view-group-register/view-group-register.controller';
import AddGroupRegisterController from './group-register/add-group-register/add-group-register.controller';
import EditGroupRegisterController from './group-register/edit-group-register/edit-group-register.controller';
import ChangeGroupController from './student-list/change-group/change-group.controller';
import ShowSubstitutionController from './working-days/show-substitution/show-substitution.controller';
import ShowCancelledActivityController from './working-days/show-cancellation/show-cancellation.controller';
import ShowWorkDayController from './working-days/show-work-day/show-work-day.controller';
import ManageStudentsController from './tags/edit-tag/manage-students/manage-students.controller';

import './informations.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.informations', [])
  .component('schedulePointsComponent', SchedulePoints)
  .component('targetsComponent', Targets)
  .component('activitiesComponent', Activities)
  .component('workingDaysComponent', WorkingDays)
  .component('categoriesOfDepartureComponent', CategoriesOfDeparture)
  .component('studentListComponent', StudentList)
  .component('groupsComponent', Groups)
  .component('employeesComponent', Employees)
  .component('schoolClassesComponent', SchoolClasses)
  .component('permissionsComponent', Permissions)
  .component('tagsComponent', Tags)
  .component('editTagComponent', EditTag)
  .component('modificationLockComponent', DataModification)
  .controller('InformationsController', InformationsController)
  .controller('ViewGroupRegisterController', ViewGroupRegisterController)
  .controller('AddGroupRegisterController', AddGroupRegisterController)
  .controller('EditGroupRegisterController', EditGroupRegisterController)
  .controller('ChangeGroupController', ChangeGroupController)
  .controller('ShowSubstitutionController', ShowSubstitutionController)
  .controller('ShowCancelledActivityController', ShowCancelledActivityController)
  .controller('ShowWorkDayController', ShowWorkDayController)
  .controller('ManageStudentsController', ManageStudentsController)
  .config(config)
  .name;
